export const FETCHING_VEHICLE_COMBOS = '@@toyota/FETCHING_VEHICLE_COMBOS';
export const FETCHED_VEHICLE_COMBOS = '@@toyota/FETCHED_VEHICLE_COMBOS';
export const FETCHED_VEHICLE_COMBOS_FAILED = '@@toyota/FETCHED_VEHICLE_COMBOS_FAILED';

export const FETCHING_VEHICLE_COMBO_BY_CHASIS = '@@toyota/FETCHING_VEHICLE_COMBO_BY_CHASIS';
export const FETCHED_VEHICLE_COMBO_BY_CHASIS = '@@toyota/FETCHED_VEHICLE_COMBO_BY_CHASIS';
export const FETCHED_VEHICLE_COMBO_BY_CHASIS_FAILED = '@@toyota/FETCHED_VEHICLE_COMBO_BY_CHASIS_FAILED';


export const FETCHING_COMBOS_DATA_REPORT = '@@toyota/FETCHING_COMBOS_DATA_REPORT';
export const FETCHED_COMBOS_DATA_REPORT = '@@toyota/FETCHED_COMBOS_DATA_REPORT';
export const FETCHED_COMBOS_DATA_REPORT_FAILED = '@@toyota/FETCHED_COMBOS_DATA_REPORT_FAILED';

export const FETCHING_COMBOS_DATA_REPORT_EXCEL = '@@toyota/FETCHING_COMBOS_DATA_REPORT_EXCEL';
export const FETCHED_COMBOS_DATA_REPORT_EXCEL = '@@toyota/FETCHED_COMBOS_DATA_REPORT_EXCEL';
export const FETCHED_COMBOS_DATA_REPORT_EXCEL_FAILED = '@@toyota/FETCHED_COMBOS_DATA_REPORT_EXCEL_FAILED';


export const CLEAR_VEHICLES_COMBOS = '@@toyota/CLEAR_VEHICLES_COMBOS';
export const CLEAR_VEHICLE_COMBO_BY_CHASIS = '@@toyota/CLEAR_VEHICLE_COMBO_BY_CHASIS';
